import React, { createContext, useContext, useState, useEffect } from "react";
import { getCookie } from "./Modules/getcookie";
import axios from "axios";

const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
  const [globalValue, setGlobalValue] = useState("Hello, World!");
  const rolePermissionValue = localStorage.getItem("rolePermissionList");
  const userTypeValue = localStorage.getItem("userType") ?? [];
  const [rolePermissionList, setRolePermissionList] = useState(JSON.parse(rolePermissionValue) ?? []);
  const [userType, setUserType] = useState(userTypeValue ?? "");
  const [orgImage, setOrgImage] = useState("");
  useEffect(() => {
    console.log('rolePermissionValue', rolePermissionValue)
    localStorage.setItem("rolePermissionValue", rolePermissionList);
    localStorage.setItem("userTypeValue", userType);
  }, [rolePermissionList]);
  return (
    <GlobalContext.Provider
      value={{
        rolePermissionList,
        setRolePermissionList,
        userType,
        setUserType,
        orgImage,
        setOrgImage,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobal = () => useContext(GlobalContext);